import React from 'react';
import { twMerge } from 'tailwind-merge';
import classnames from 'classnames';
import { ListDropDown } from 'components';
import { PARTIAL_PAYMENT_OPTIONS } from 'containers/settings/constants';

interface PartialPaymentOption {
  id: string;
  name: string;
}

interface PartialPaymentsSettingSectionProps {
  selectedOption: PartialPaymentOption | null;
  onOptionChange: (option: PartialPaymentOption) => void;
  isDisabled?: boolean;
}

const PartialPaymentsSettingSection: React.FC<PartialPaymentsSettingSectionProps> = ({
  selectedOption,
  onOptionChange,
  isDisabled = false
}) => {
  const handleOptionChange = (option: PartialPaymentOption) => {
    onOptionChange(option);
  };

  return (
    <div
      className={twMerge(
        classnames({
          'pointer-events-none opacity-50': isDisabled
        })
      )}>
      <div className="flex items-center justify-between">
        <div className="flex-1">
          <div className="text-xl font-bold text-primaryText">Partial payments</div>
          <div className="mt-2 text-17px font-normal text-primaryText">
            Allow customers to make a payment less than the full amount due on the invoice.
          </div>
        </div>
        <div className="ml-6 w-[200px]">
          <ListDropDown
            id="partial-payment-dropdown"
            selectedItem={selectedOption}
            items={PARTIAL_PAYMENT_OPTIONS}
            setSelectedItem={handleOptionChange}
            disabled={isDisabled}
            buttonStyles="bg-secondaryBtn text-sbase font-medium h-10 py-2  rounded-md shadow-sm"
            itemStyle="hover:bg-highlightGray"
            spanStyles="text-headingGray"
            placeholder="Select option"
            idKey="id"
            nameKey="name"
          />
        </div>
      </div>
    </div>
  );
};

export default PartialPaymentsSettingSection;
